import { generatePath } from 'react-router';

import { ELEMENT_TYPES, POLICY, POLICY_TYPE } from '../../types/hubEnums';
import { getWebsiteDomainByCountry } from '../../util/helper/website';
import { PATH_HUB_POLICY } from '../../util/pagePath';

interface Choice {
  text: string;
  to: string;
  elementType?: ELEMENT_TYPES;
}

export function useGetPolicies(country?: string): Array<Choice> {
  const domain = getWebsiteDomainByCountry(country);

  return [
    { text: `${POLICY.PRIVACY} policy`, to: generatePath(PATH_HUB_POLICY, { policyType: POLICY_TYPE.PRIVACY }) },
    {
      text: `${POLICY.REFUND} policy`,
      to: `${domain}/refund-policy`,
      elementType: ELEMENT_TYPES.ANCHOR,
    },
    {
      text: POLICY.STUDENT_AGREEMENT,
      to: generatePath(PATH_HUB_POLICY, { policyType: POLICY_TYPE.STUDENT_AGREEMENT }),
    },
    { text: POLICY.DATA_COLLECTION, to: generatePath(PATH_HUB_POLICY, { policyType: POLICY_TYPE.DATA_COLLECTION }) },
    {
      text: POLICY.SERVICE_FEES,
      to: `${domain}/service-fees`,
      elementType: ELEMENT_TYPES.ANCHOR,
    },
  ];
}
